<template>
  <a class="quick-launch-link" @click="onSwitchItem">
    <div class="quick-launch-link-title">
      <div class="default-icon" v-if="isNeedToShowDefaultIcon">{{getInitialsLetters}}</div>
      <img class="app-icon" v-if="isNeedToShowApplicationIcon" :src="icon" @error="onImageLoadFailure"></img>
    </div>
    <div class="quick-launch-app-name ellipsis">
      {{title}}
    </div>
  </a>
</template>

<script>

  let lpUtils = require('../../../../assets/js/utils/lpUtils.js');

  export default {

    name: 'quick-launch-link',
    props: {
      title: String,
      url: String,
      iconURL: String
    },
    data: function () {
      return {
        showDefaultIcon: false,
      }
    },
    computed: {
      getInitialsLetters: function () {
        return lpUtils.initialsFromString(this.title);
      },
      icon() {
        if (typeof this.iconURL !== 'undefined'){
          return this.iconURL;
        } else {
          this.showDefaultIcon = true;
        }
      },
      isNeedToShowDefaultIcon() {
        return this.showDefaultIcon;
      },
      isNeedToShowApplicationIcon() {
        return !this.showDefaultIcon;
      }
    },
    methods: {
      onSwitchItem(event) {
        event.stopPropagation();
        window.LE.navigator.open(this.url, '_blank');
        this.$emit('clicked');
      },
      onImageLoadFailure () {
        this.showDefaultIcon = true;
        // logger.debug("Quick launch item " + this.title + " failed to load icon fallback to default");
      }
    }
  }
</script>

<style lang='scss' scoped>

  @import "../../../../assets/scss/global";
  @import "../../../../assets/scss/mixins";

  .quick-launch-link {
    display: flex;
    flex-flow: column nowrap;
    cursor: pointer;
    white-space: nowrap; // prevent menu item from flowing into more than one line
    padding: 10px;
    alignment: center;
    vertical-align: center;
    transform: scaleY(-1);
    @include transition-duration(100ms);
    @include transition-property(background-color, color);
    @include transition-timing-function(swing);
    box-sizing: border-box;

    .quick-launch-link-icon-disabled {
      display: none;
    }

    .quick-launch-link-title {
      font-family: Roboto;
      font-size: 12px;
      font-weight: normal;
      font-style: normal;
      font-stretch: normal;
      letter-spacing: normal;
      @include themify {
        border: 1px solid getColor('quick-launch-app-icon-border-color', 'framework');
        background-color: getColor('quick-launch-app-icon-bg-color', 'framework');
        @include box-shadow(
            getSize('quick-launch-app-shadow-color-h-offset', 'framework')
            getSize('quick-launch-app-shadow-color-v-offset', 'framework')
            getSize('quick-launch-app-shadow-color-blur', 'framework')
            getSize('quick-launch-app-shadow-color-spread', 'framework')
            getColor('quick-launch-app-icon-border-shadow', 'framework')
        );
      };
      width: 60px;
      height: 60px;
      border-radius: 12px;
      overflow: hidden;

      .default-icon {
        display: flex;
        justify-content:center;
        align-items:center;
        height: 100%;
        -webkit-box-direction: normal;
        margin: 0;
        padding: 0;
        font: inherit;
        -webkit-font-smoothing: antialiased;
        outline: none;
        /*border-radius: 12px;*/
        object-fit: fill;
        font-weight: 400;
        letter-spacing: 1px;
        text-align: center;
        vertical-align: middle;
        font-size: 24px;
        line-height: 50px;
        @include themify {
          text-shadow: 1px 1px 0 getColor('quick-launch-app-default-icon-text-shadow', 'framework'),
          1px -1px 0 getColor('quick-launch-app-default-icon-text-shadow', 'framework'),
          -1px 1px 0 getColor('quick-launch-app-default-icon-text-shadow', 'framework'),
          -1px -1px 0 getColor('quick-launch-app-default-icon-text-shadow', 'framework'),
          1px 0px 0 getColor('quick-launch-app-default-icon-text-shadow', 'framework'),
          0px 1px 0 getColor('quick-launch-app-default-icon-text-shadow', 'framework'),
          -1px 0px 0 getColor('quick-launch-app-default-icon-text-shadow', 'framework'),
          0px -1px 0 getColor('quick-launch-app-default-icon-text-shadow', 'framework'),
          0px 2px 4px rgba(0,0,0,0.5);
            color: getColor('applicationLogoText', 'framework');
            border: solid 1px getColor('applicationLogoBorder', 'framework');
          }

        .hover & {
          @include themify {
            border: solid 1px getColor('applicationLogoBorderHover', 'framework');
          }
        }

        transition: all 0.3s ease;
      }

      .app-icon {
        display: flex;
        margin: auto;
        width: 100%;
        height: 100%;
        object-fit: contain;
      }

      &:hover {
        @include themify {
          border: 1px solid getColor('quick-launch-app-icon-hover-border-color', 'framework');
          background-color: getColor('quick-launch-app-icon-hover-bg-color', 'framework');
          @include box-shadow(
              getSize('quick-launch-app-hover-shadow-color-h-offset', 'framework')
              getSize('quick-launch-app-hover-shadow-color-v-offset', 'framework')
              getSize('quick-launch-app-hover-shadow-color-blur', 'framework')
              getSize('quick-launch-app-hover-shadow-color-spread', 'framework')
              getColor('quick-launch-app-icon-hover-border-shadow', 'framework')
          );
        };
      }


    }

    .quick-launch-app-name {
      display: block;
      display: -webkit-box;
      max-width: 100%;
      line-height: 1em;
      height: 3em;       /* height is 2x line-height, so two lines will display */
      margin: 0 auto;
      font-size: 11px;
      font-weight: 500;
      font-stretch: normal;
      font-style: normal;
      /*line-height: normal;*/
      letter-spacing: normal;
      white-space: pre-line;
      /*line-height: 1;*/
      -webkit-line-clamp: 3;
      -webkit-box-orient: vertical;
      overflow: visible;
      text-overflow: ellipsis;
      @include themify {
        color: getColor('quick-launch-app-text-color', 'framework');
      }
      width: 60px;
      text-align: center;
    }

    &.disabled {
       color: $gray40;
       cursor: default;
    }
    .quick-launch-link-indicator {
      right: 15px;
      position: absolute;
      font-size: 12px;
      font-weight: normal;
      margin-left: 5px;
      margin-top: 1px;
    &.green {
       color: $green;
     }
    &.red {
       color: $red;
     }
    }
  }

  .quick-launch-icon {
    text-align: center;
    vertical-align: top;
    display: table-cell;
    width: 27px;
    height: 27px;
    @include border-radius(3px);
    border: 1px solid $gray50;
    font: 14px arial;
    text-transform: uppercase;
    color: $gray75;
    padding: 0;
  }

</style>
